
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from '@webapp/ui';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [RouterOutlet, ToastComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
})
export class AppComponent {
	title = 'Autheticaction';
}
